<template>
  <div>
    <el-tabs v-model="activeName" :stretch="true">
      <el-tab-pane label="按时间" name="first">
        <dateTabs @changDate="changDate"></dateTabs>
        <div v-if="doctorListBydate.length>0">
          <div v-for="(item,index) in doctorListBydate" :key="index" @click="toDoctorDetails(item)">
            <doctorInfo v-if="item.DoctorInfo"
                        :name="item.DoctorInfo.doc_name" :profession="item.DoctorInfo.doc_title"
                        :avatarUrl="item.DoctorInfo.doc_image?item.DoctorInfo.doc_image:'static/img/doctor.png'"
                        :price="item.金额" :surplus="item.该天余号数量" :introduce="item.DoctorInfo.doc_expert">
            </doctorInfo>
          </div>
        </div>
        <div class="noCard" v-if="!doctorListBydate.length>0">
          <div class="noCard-img">
            <img src="static/img/noCard.png"/>
          </div>
          <div class="noCard-text">暂无排班医生</div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="按医生" name="second">
        <div v-if="doctorListByyz.length>0" v-for="(item,index) in doctorListByyz" :key="index" @click="toDoctorDetails(item)">
          <doctorInfo  v-if="item.DoctorInfo"
                      :name="item.DoctorInfo.doc_name" :profession="item.DoctorInfo.doc_title"
                       :avatarUrl="item.DoctorInfo.doc_image?item.DoctorInfo.doc_image:'static/img/doctor.png'"
                      :price="item.金额" :surplus="item.DoctorInfo.TotalHaoYuanNum" :introduce="item.DoctorInfo.doc_expert">
          </doctorInfo>
        </div>
        <div class="noCard" v-if="!doctorListByyz.length>0">
          <div class="noCard-img">
            <img src="static/img/noCard.png"/>
          </div>
          <div class="noCard-text">暂无排班医生</div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import doctorInfo from '../common/DoctorInfo'
  import dateTabs from  '../common/DateTabs'
  import {getpaibanYs} from '../../api/index'
    export default {
      data(){
        return{
          activeName:'first',
          dates:[],
          currentDateIndex:0,
          doctorList:[],//所有数据
          doctorListBydate:[],//按时间
          doctorListByyz:[],//按医生,
          cIndex:0,
          cDate:''
        }
      },
      components:{
        doctorInfo,
        dateTabs
      },
      created() {
        //修改标题 获取上个页面传过来的数据
        document.title = this.$route.query.ksname
        this.getpaibanYs()
        this.cDate = this.getDateYYMMDD(new Date())
      },
      mounted() {
      },
      methods:{
        //获取医生排班列表
        getpaibanYs(){
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          getpaibanYs({
            ksId:this.$route.query.ksId
          }).then(res=>{
            loading.close();
            this.doctorList = res.Data
            //按时间
            this.doctorListBydate = res.Data.filter(item => item.日期 == this.getDateYYMMDD(new Date()))
            //按医生
            const map = new Map();
            this.doctorListByyz = res.Data.filter((a) => !map.has(a.医生代码) && map.set(a.医生代码, 1))
          })
        },
        // 根据时间获取医生排班列表
        getpaibanBydate(date){
          this.doctorListBydate = this.doctorList.filter(item => item.日期 == date)
        },
        //切换时间
        changDate(date){
          this.cIndex = date.index
          this.cDate = date.date
          this.getpaibanBydate(date.date)
        },
        //下一页面
        toDoctorDetails(item){
          this.$router.push({path:'/doctorDetails',query:{
              doctorImg:item.DoctorInfo.doc_image,
              name:item.DoctorInfo.doc_name,
              ksname:this.$route.query.ksname,
              profession:item.DoctorInfo.doc_title,
              count:item.DoctorInfo.reg_count,
              doctorId:item.医生代码,
              introduce:item.DoctorInfo.doc_expert,
              desc:item.DoctorInfo.doc_desc,
              cIndex:this.cIndex,
              cDate:this.cDate,
              ksId:this.$route.query.ksId
          }})
        },
        //获取date的年-月-日
        getDateYYMMDD(date){
          let myDate = new Date(date)
          let yy = myDate.getFullYear();
          let mm = String((myDate.getMonth() + 1) < 10 ? '0' + (myDate.getMonth() + 1) : (myDate.getMonth() + 1))
          let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
          return yy + '-' +mm + '-' + dd
        },
      }
    }
</script>

<style scoped>
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 0 0;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/outpatient.vue